import { RecordList } from './RecordList';
export default RecordList;
